import { Box, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import brandLockup from '../../../asset/logo/lockup-horizontal-color.svg';
import { BLUE_TEXT, BORDER, CONTENT_MAX_WIDTH, INTER, PAGE_GUTTER, SLATE } from '../publicStyles';

const footerLinkSx = { fontFamily: INTER, fontSize: 14, fontWeight: 600, color: BLUE_TEXT, minHeight: 44, display: 'inline-flex', alignItems: 'center' } as const;

export default function PublicFooter() {
    return (
        <Box component="footer" sx={{ backgroundColor: '#FFFFFF', borderTop: `1px solid ${BORDER}` }}>
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 2, sm: 3 }} alignItems={{ xs: 'flex-start', sm: 'center' }}
                sx={{ maxWidth: CONTENT_MAX_WIDTH, mx: 'auto', px: PAGE_GUTTER, py: 4 }}>
                <Box component="img" src={brandLockup} alt="VerbaSchola" sx={{ height: 22, width: 'auto' }} />
                <Typography sx={{ fontFamily: INTER, fontSize: 13, color: SLATE }}>
                    Speaking practice for language classrooms.
                </Typography>
                <Stack direction="row" spacing={3} flexWrap="wrap" useFlexGap sx={{ ml: { sm: 'auto' } }}>
                    <Link href="mailto:support@verbaschola.com" underline="hover" sx={footerLinkSx}>Help &amp; support</Link>
                    <Link component={RouterLink} to="/mockup/public/login" underline="hover" sx={footerLinkSx}>Log in</Link>
                    <Link component={RouterLink} to="/mockup/public/pilot" underline="hover" sx={footerLinkSx}>Request a pilot</Link>
                </Stack>
            </Stack>
            <Typography sx={{ fontFamily: INTER, fontSize: 12, color: SLATE, textAlign: 'center', pb: 3, px: 2 }}>
                © 2026 VerbaSchola Inc.
            </Typography>
        </Box>
    );
}
